import axios from 'axios';

export function requestGetCurrency() {
    return axios.request({
        method: 'get',
        url: "https://api.exchangerate.host/latest?base=AED",
    })
}
